<script>
import Swal from "sweetalert2";

import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import ItemsApi from "@/services/items-api";

export default {
  page: {
    title: "Ajouter des articles",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout},
  data() {
    return {
        imageModalSelectedItem:'',
        itemsFilter: '',
        isItemsTableBusy: false,
        itemsList: [],
        pagemodelMain: {currentPage : 1, perPage : 15, totalRows: 0},
        showImageModal: false,
        showBrandModal:false,
        imageModalUrl: '',
        selectedItem: {
            id:null,
            title:null,
            ref: null,
            logo:null,
            price: null,
            taxPercent:0,
            vatPercent:0,
            discount:0,
            gratuity:{gratuity:0, gratuityGranted:0},
            multiple:1,
            isAvailable:1,
            brand: null,
            isVisible:1,
            category:{name:'',value:null},
            itemGroup:null,
            priority: null,
        },
        endOfFindItems:false,
        formData: null,
        selectedImage: null,
        selectedCSV: null,
        maxFileSize: null,
        selectedBrand: null,
        brandsList: [],
        categoriesList:[{name :"Pharmaceutique",value: 0},{name :"Parapharmaceutique", value: 1}],
        selectedBrandDiscount:null,
        selectedBrandGratuity:[],
        newBrandName:null,
        editedBrand: null,
        editedName:'',
        if_form_error:null,
        if_form_error_message:"Vérifier les champs obligatoires !",
        groupsList:[],
        selecteddGroup:null,
        showGroupModal:false,
        selectedGroupDiscount:null,
        selectedGroupGratuity:[],
        newGroupName:null,
        editedGroup:null,
        editedGroupName:null,

    };
  }, 
    mounted(){
    this.findItems();
    this.cancelEdit();
    this.getMaxFileSize();
    this.getAllBrands();
    this.getAllGroups()
    this.if_form_error=false
  },
    methods: {

    addTier() {
        this.selectedItem.gratuity.push({
            quantity: 0,
            gratuityGranted: 0
        });
    },

    removeTier(index) {
        this.selectedItem.gratuity.splice(index, 1);
    },

    addGroupTier() {
        this.selectedGroupGratuity.push({
            quantity: 0,
            gratuityGranted: 0
        });
    },

    removeGroupTier(index) {
        this.selectedGroupGratuity.splice(index, 1);
    },


    addBrandTier() {
        this.selectedBrandGratuity.push({
            quantity: 0,
            gratuityGranted: 0
        });
    },

    removeBrandTier(index) {
        this.selectedBrandGratuity.splice(index, 1);
    },


    getMaxFileSize(){
        ItemsApi.getMaxFileSize().then(
            size => {
                this.maxFileSize=size;
            })
    },
    findItems() {
      this.isItemsTableBusy = true;
      ItemsApi.findItemsSupplier(this.itemsFilter, this.pagemodelMain.currentPage, this.pagemodelMain.perPage)
        .then(itemsList => {
          this.itemsList = itemsList.list
          this.pagemodelMain.totalRows = itemsList.total;
          this.pagemodelMain.currentPage = itemsList.page;
          this.pagemodelMain.perPage = itemsList.pageSize;
          this.pagemodelMain.pageSize = itemsList.pageSize;
        })
        .finally(() => {
        this.isItemsTableBusy = false;
        this.endOfFindItems =true;
      })
    },

    cancelEdit(){
        this.if_form_error=false;
        this.selectedItem= {
            id:null,
            title:null,
            ref: null,
            logo:null,
            price: null,
            taxPercent:0,
            vatPercent:0,
            discount:0,
            gratuity:[],
            multiple:1,
            isAvailable:1,
            brand: null,
            isVisible:1,
            category:{name:'',value:null},
            itemGroup:null,
            priority: null,
        };

    },
    
    edit(data){
        this.$refs['active-tab'].activate()
        this.cancelEdit();
        this.selectedItem.id = data.id;
        this.selectedItem.title = data.title;
        this.selectedItem.ref = data.ref;
        this.selectedItem.logo = data.logo;
        this.selectedItem.price = data.priceAsFloat;
        this.selectedItem.taxPercent = data.taxPercent;
        this.selectedItem.vatPercent =  data.vatPercent;
        this.selectedItem.discount=data.discount;
        this.selectedItem.gratuity=data.gratuity;
        this.selectedItem.multiple=data.multiple;
        this.selectedItem.priority = data.priority;
        this.selectedItem.isAvailable=data.isAvailable;
        this.selectedItem.brand=data.brand;
        this.selectedItem.isVisible=data.isVisible;
        this.selectedItem.category.value=data.category;
        this.selectedItem.category.name=data.category===0 ? 'Pharmaceutique' : 'Parapharmaceutique' ;
        this.selectedItem.itemGroup=data.itemGroup


    },

    isInt(n) {
        return n % 1 === 0;
    },
    
    confirm(){

        this.if_form_error= !this.selectedItem.title || !this.selectedItem.ref || !this.selectedItem.price
                            || this.selectedItem.taxPercent=== null || this.selectedItem.vatPercent===null
                            || this.selectedItem.title==='' || this.selectedItem.ref==='' || this.selectedItem.price===''
                            ||this.selectedItem.taxPercent==='' || this.selectedItem.vatPercent==='';

        if (this.if_form_error) {
            this.if_form_error_message="Vérifier les champs obligatoires !";
            return;
        }

        this.if_form_error = !this.isInt(this.selectedItem.multiple);

        if (this.if_form_error) {
             this.if_form_error_message="Remise et multiple doivent être des entiers";
            // this.if_form_error_message="TVA, Taxe, Remise, Gratuités et multiple doivent être des entiers";
            return;
        }

        //send the category in an integer form 
        this.selectedItem.category= this.selectedItem.category == null ? null : this.selectedItem.category.value;

        //Check if this creation of new item or item edition
        //if new item, swal ask is not needed
        if (this.selectedItem.id == null) {
            ItemsApi.saveItem(this.selectedItem)
            .then((res) =>{
                if (res) {
                    this.findItems()
                    this.cancelEdit();
                    this.if_form_error=false
                }
            }) 
            return;
        }
        
        Swal.fire({
            title: this.selectedItem.id ? 'Modifier' : 'Ajouter',
            html: this.selectedItem.title,
            icon: "info",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            cancelButtonText: "Annuler",
            confirmButtonText: this.selectedItem.id ? 'Oui, modifier' : 'Oui, ajouter'
        }).then(result => {
            if (result.value) {
                ItemsApi.saveItem(this.selectedItem)
                .then((res) =>{
                    if (res) {
                        this.findItems()
                        this.cancelEdit();
                        this.if_form_error=false
                    }
                    }) 
            }
        })
    },
    removeItem(item) {
        Swal.fire({
            title: "Supprimer ?",
            html: item.title,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            cancelButtonText: "Annuler",
            confirmButtonText: "Oui, supprimer!"
        }).then(result => {
            if (result.value) {
                ItemsApi.removeItem(item.id)
                .then(() =>{
                    this.findItems()
                    this.cancelEdit();
                    }) 
            }
        })
    },
    uploadImage(id){
        const fd = new FormData();
        fd.append('file', this.selectedImage, this.selectedImage.name)
        ItemsApi.uploadImage(fd,id).then(
            res => {
                if(res)
                {this.imageModalUrl = "/api/image/get/" + res;
                this.findItems();}
            }
        );
    },
        
    onImageUpload(event) {
        this.selectedImage=event.target.files[0];
        this.uploadImage(this.imageModalSelectedItem.id) 

    },

    deleteImage(imageModalSelectedItem) {
        Swal.fire({
            title: "Supprimer l'image ?",
            html: this.imageModalSelectedItem.title ,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            cancelButtonText: "Annuler",
            confirmButtonText: "Oui, supprimer !"
        }).then(result => {
            if (result.value) {
                ItemsApi.deleteImage(imageModalSelectedItem.id)
                .then(() =>{
                    this.imageModalUrl = "/api/image/get/unavailable";
                    this.findItems()
                    }) 
            }
        })
    }, 

    onCSVUpload(){
        if(!this.selectedCSV) {
            return;
        }

        const fd = new FormData();
        fd.append('file', this.selectedCSV, this.selectedCSV.name)
        ItemsApi.uploadCSV(fd).then(
            () =>{
                this.findItems();
                this.selectedCSV=null
                }
        )
    },
    addNewBrand(newBrandName){
        ItemsApi.addNewBrand(newBrandName).then(
            ()=> {
                this.newBrandName=null;
                this.getAllBrands();
            }
        )

    },

    addNewGroup(newGroupName){
        ItemsApi.addNewGroup(newGroupName).then(
            ()=> {
                this.newGroupName=null;
                this.getAllGroups();
            }
        )
    },

    getAllBrands(){
        ItemsApi.getAllBrands().then(
            result => {
                this.brandsList=result;
            }
        )
    },

    getAllGroups(){
        ItemsApi.getAllGroups(null).then(
            result => {
                this.groupsList=result;
            }
        )
    },

    editBrand(brand){
        this.editedName=''
        this.editedBrand=brand;
    },

    editGroup(itemGroup){
        this.editedGroupName=''
        this.editedGroup=itemGroup;

    },

    cancelBrand(){
        this.editedBrand=null;
        this.editedName='';
    },

    cancelGroup(){
        this.editedGroup=null;
        this.editedGroupName='';
    },
    saveModif(brand){
        ItemsApi.changeBrandName(brand, this.editedName).then(
            ()=>{
                this.getAllBrands()
                this.findItems();
                this.cancelBrand()
            }
        )
    },

    saveGroupModif(itemGroup){
        ItemsApi.changeGroupName(itemGroup, this.editedGroupName).then(
            ()=>{
                this.getAllGroups()
                this.findItems();
                this.cancelGroup()
            }
        )

    },

    deleteBrand(brand) {
        Swal.fire({
            title: "Supprimer cette marque de tous les Articles ?",
            html: brand.name ,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            cancelButtonText: "Annuler",
            confirmButtonText: "Oui, supprimer!"
        }).then(result => {
            if (result.value) {
                ItemsApi.deleteBrand(brand)
                .then(() =>{
                this.getAllBrands()
                this.findItems()
                this.cancelBrand()
                    }) 
            }
        })
    },
    deleteGroup(itemGroup){
      Swal.fire({
            title: "Supprimer ce groupe de tous les Articles ?",
            html: itemGroup.name ,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            cancelButtonText: "Annuler",
            confirmButtonText: "Oui, supprimer!"
        }).then(result => {
            if (result.value) {
                ItemsApi.deleteGroup(itemGroup)
                .then(() =>{
                this.getAllGroups()
                this.findItems()
                this.cancelGroup()
                    }) 
            }
        })
    },

    groupModif(){

        let discountMsg = this.selectedBrandGratuity
            ? "Remises du Groupe: " + this.selectedBrandDiscount + "\n"
            : '';

        let gratuityMsg = '';
        if (this.selectedBrandGratuity && Array.isArray(this.selectedBrandGratuity)) {
            if (this.selectedBrandGratuity.length > 0) {
                gratuityMsg = "Gratuités du Groupe: " + 
                    this.selectedBrandGratuity
                        .map(tier => tier.gratuity + " -> " + tier.gratuityGranted)
                        .join(", ");
            }
        }

        let finalMsg = discountMsg + gratuityMsg;

        Swal.fire({
        title: "Confirmer la modification groupée de la marque "+this.selectedBrand.name+"? \n",
        html:finalMsg,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui, modifier!"
        }).then(result => {
            if (result.value) {
                ItemsApi.groupModification(this.selectedBrand,this.selectedBrandDiscount,this.selectedBrandGratuity)
                .then(() =>{
                this.findItems()
                this.cancelModification();

                    }) 
            }
        })

    },

    groupModifForGroup(){
                let discountMsg = this.selectedGroupDiscount
            ? "Remises du Groupe: " + this.selectedGroupDiscount + "\n"
            : '';

        let gratuityMsg = '';
        if (this.selectedGroupGratuity && Array.isArray(this.selectedGroupGratuity)) {
            if (this.selectedGroupGratuity.length > 0) {
                gratuityMsg = "Gratuités du Groupe: " + 
                    this.selectedGroupGratuity
                        .map(tier => tier.gratuity + " -> " + tier.gratuityGranted)
                        .join(", ");
            }
        }

        let finalMsg = discountMsg + gratuityMsg;
        Swal.fire({
        title: "Confirmer la modification groupée du groupe "+this.selecteddGroup.name+"? \n",
        html:finalMsg,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui, modifier!"
        }).then(result => {
            if (result.value) {
                ItemsApi.groupModificationForGroup(this.selecteddGroup,this.selectedGroupDiscount,this.selectedGroupGratuity)
                .then(() =>{
                this.findItems()
                this.cancelGroupModification();

                    }) 
            }
        })

    },


    cancelModification(){
        this.selectedBrand=null;
        this.selectedBrandDiscount='';
        this.selectedBrandGratuity='';
    },

    cancelGroupModification(){
        this.selecteddGroup=null;
        this.selectedGroupDiscount='';
        this.selectedGroupGratuity='';
    },

    }
};
</script>

<style scoped>
    @media screen and (max-width: 1550px) {
        .custom-input-file-width {
            width: 80%;
        }
    }

    @media screen and (min-width: 1551px) {
        .custom-input-file-width {
            width: 90%;
        }
    }
</style>

<template>
  <Layout>
    <div class="row pt-4">
      <div class="col-sm-12">
        <div class="card" style="border: 1px solid rgb(205, 211, 217)">
          <div class="card-body">
            <h2 class="card-title font-size-25" style="font-size:25px;">Catalogue <span class="d-none d-sm-inline   ">des Articles</span></h2>
            <p class="card-title-desc font-size-14">
              Liste des articles 
            </p>
            <div class="row p-0 m-0 ">
                <div class ="col-lg-9 col-sm-12 pb-4 ">
                    <b-input-group  >
                    <b-form-input placeholder="Chercher par Référence ou Désignation ou Marque ou Groupe"  v-model="itemsFilter"   @keyup.native.enter="findItems()"
                        ></b-form-input>                              
                    <template v-slot:append>
                        <b-button variant="success" @click="findItems()">
                        <i class="bx bx-search-alt font-size-16 align-middle"></i>
                        </b-button>
                    </template>
                    </b-input-group>
                </div>
                <div class="col-lg-3 col-sm-12 pl-sm-2 pb-4 d-none d-lg-block">
                    <div class="custom-file custom-input-file-width" style="float:left;">
                         <b-form-file
                        v-model="selectedCSV"
                         ref="fileUpload"
                        placeholder="Importer"
                        drop-placeholder="Placez le CSV ici"
                        @input="onCSVUpload"
                        ></b-form-file>
                    </div>
                    <div class="p-sm-2 pt-2" style="float:right">
                        <a id="popover-target-1" ><i class="fas fa-question text-primary font-size-18"></i></a>
                          <b-popover target="popover-target-1" triggers="hover" placement="top" variant="info">
                            <template #title>Guide pour l'import des Articles</template>
                            Vous pouvez télécharger le modèle du fichier CSV en cliquant sur ce <a href="/modele-import-articles.csv" class="font-size-14 font-weight-bold text-warning"> <u> lien </u> </a> <br>
                        </b-popover>
                    </div>
                </div>
            </div>
            <div class="row ">
                <div class ="col-lg-9 col-md-9 col-sm-7 col-xs-12">
                    <div class="card border border-info bg-Default">
                    <div class="table-responsive mb-0"  style="height:1200px">
                    <table class="table table-centered table-fixed ">
                        <thead class="thead-light">
                            <tr>
                                <th class="text-left">Désignation</th>
                                <th class="text-left d-md-table-cell d-none">Référence </th>
                                <th class="text-left d-md-table-cell d-none">Marque </th>
                                <th class="text-left d-md-table-cell d-none">Groupe </th>
                                <th class="text-center">Image</th>
                                <th class="text-right d-md-table-cell d-none">Catégorie </th>
                                <th class="text-right d-md-table-cell d-none" style="width:130px">Prix HT</th>
                                <th class="text-right d-md-table-cell d-none">Remise</th>
                                <th class="text-right d-md-table-cell d-none">Gratuités</th>
                                <th class="text-right d-sm-table-cell d-none" style="width:130px">Prix HT Négocié</th>
                                <th class="text-right d-md-table-cell d-none">Stock</th>
                                <th class="text-left d-md-table-cell d-none"> Multiple</th>
                                <th class="text-right d-md-table-cell d-none"> Visibilité</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody>

                        <tr v-for="data in itemsList" :key="data.id" >
                            <td class="text-left font-weight-bold font-size-14">{{data.title}}</td>
                            <td class="text-left d-md-table-cell d-none">{{data.ref}}</td>
                            <td class="text-left d-md-table-cell d-none" v-if="data.brand===null">{{data.brand}}</td>
                            <td class="text-left d-md-table-cell d-none" v-else>{{data.brand.name}}</td>
                            <td class="text-left d-md-table-cell d-none" v-if="data.itemGroup===null">{{data.itemGroup}}</td>
                            <td class="text-left d-md-table-cell d-none" v-else>{{data.itemGroup.name}}</td>
                            <td class="text-center">
                                <img v-bind:src="'/api/image/get/' + data.image" @click="imageModalUrl= '/api/image/get/' + data.image;showImageModal = true; imageModalSelectedItem=data" alt height="40" width="60" style="cursor: pointer;" />
                            </td>
                            <td class="text-right d-md-table-cell d-none" >
                                <span  class="font-size-13"
                                :class="data.category===0 ? 'badge ml-1 badge-success badge-pill' : 'badge ml-1 badge-secondary   badge-pill' ">{{data.category===0 ? 'Pharma' : 'P. Para'}}
                                </span>
                            </td>           
                            <td class="text-right font-size-14 d-md-table-cell d-none">{{data.price}}</td>
                            <td v-if="data.discount===null || data.discount===0" class="text-right font-weight-bold font-size-14 d-md-table-cell d-none"></td>

                            <td v-else  class="text-right font-weight-bold font-size-14 d-md-table-cell d-none">{{data.discount}} %</td>

                            <td v-if="!data.gratuity || data.gratuity.length === 0 " class="text-right font-weight-bold font-size-14">
                            </td>

                            <td v-else
                                class="text-right pull-right font-weight-bold font-size-14">

                            <div v-for="(gratuity, index) in data.gratuity" :key="index">
                                <span v-if="gratuity.gratuity > 0 && gratuity.gratuityGranted > 0"
                                class="badge badge-primary font-size-14 m-1"
                                >
                                <i class="fas fa-star mr-2"></i>
                                {{ gratuity.gratuity }} +{{ gratuity.gratuityGranted }}
                                </span>
                            </div>

                            </td>
                            

                            <td class="text-right font-weight-bold text-success font-size-14 d-sm-table-cell d-none">{{data.discountedPrice}}</td>

                            <td class="text-center d-md-table-cell d-none"> 
                            <i v-if="!data.isAvailable" title="Non disponible" class="bx bx-x-circle text-danger font-size-18"> </i>
                            <i v-if="data.isAvailable" title="Disponible en stock" class="fas fa-check-double text-primary font-size-16"> </i>
                            </td>
                            <td class="text-left d-md-table-cell d-none"><span  class="font-size-14 font-weight-bold d-md-table-cell d-none">{{data.multiple}} </span></td>
                            <td class="text-center d-md-table-cell d-none"> 
                                <i :class="data.isVisible ? 'far fa-eye text-primary' : 'far fa-eye-slash text-danger' " ></i>
                            </td>
                            <td>
                                <a  title="modifier" href="javascript:void(0);"  @click="edit(data)" :class="data.id ? '' : 'd-none'" class="action-icon text-warning pr-2" >
                                    <i class="mdi mdi-pencil font-size-22"  />
                                </a>
                                <a  title="supprimer" href="javascript:void(0);"  @click="removeItem(data)" :class="data.id ? '' : 'd-none'" class="action-icon text-danger " >
                                    <i class="mdi mdi-trash-can font-size-22 " />
                                </a>

                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div v-if="isItemsTableBusy" class="d-flex justify-content-center">
                        <div class="spinner-border text-success" role="status">
                            <span class=" sr-only">Chargement...</span>
                        </div>
                    </div>
                    <span v-if="!isItemsTableBusy & !itemsList.length & endOfFindItems" class="d-flex justify-content-center m-4 text-danger" >Aucun article dans la liste</span>
                    </div>

                    </div>
                    <!-- Pagination -->
                    <div class="row pt-3 mb-sm-4">
                        <div class="col-sm-8">
                            <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                                <b-form-select @input="findItems()"  v-model="pagemodelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                                <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} lignes</span></div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="dataTables_paginate paging_simple_numbers float-right">
                                <ul class="pagination pagination-rounded mb-0">
                                <b-pagination v-model="pagemodelMain.currentPage" :disabled="isItemsTableBusy" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="findItems()" ></b-pagination>
                                </ul>
                            </div>
                        </div>
                    </div> 
                    <!-- Fin Pagination  -->
                </div>
                <div class="col-lg-3 col-md-3 col-sm-5 col-xs-12" style=" padding-left: 10px; padding-right: 11px;">
                    <b-tabs justified nav-class="nav-tabs-custom" content-class="p-0 text-muted" align="center" active-nav-item-class="font-weight-bold text-uppercase ">
                        <b-tab ref="active-tab" lazy >
                            <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                                <i class="fas fa-edit  font-size-16"></i>
                            </span>
                            <i class="d-none d-sm-inline-block fas fa-edit font-size-12 pr-2"/><span class="d-none d-md-inline-block font-size-12">Articles</span>
                            </template>
                            <h5 id="tooltip-top" class="truncate-title  card-title pt-sm-0 pt-4 mt-sm-4  mb-2 text-secondary text-center">{{selectedItem.id ? selectedItem.title : 'Ajouter un Nouvel Article'}}</h5><br> 
                            <b-tooltip v-if="selectedItem.id" target="tooltip-top" variant="info">{{this.selectedItem.title }}</b-tooltip>

                                <form class="needs-validation" >

                                    <b-form-group>
                                        <b-form-checkbox
                                            value="1"
                                            unchecked-value="0"
                                            class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                                            v-model="selectedItem.isVisible"
                                            >   
                                            <span class="font-size-14" :class="selectedItem.isVisible == 1 ? 'text-primary' : 'text-muted'">Visible dans le catalogue</span>
                                        </b-form-checkbox>
                                    </b-form-group>

                                    <b-form-group>
                                        <label for="designation" class="pt-1 pb-1 font-size-14 font-weight-bold">Designation <span class="text-danger mb-2" style="font-size:9px">(obligatoire)</span></label>
                                        <input
                                        id="designation"
                                        type="text"
                                        class="form-control font-size-13 "
                                        v-model="selectedItem.title"
                                        />
                                    </b-form-group>
                                    <b-form-group>
                                        <label for="ref" class="pt-1 pb-1 font-size-14 font-weight-bold">Reference <span class="text-danger mb-2" style="font-size:9px">(obligatoire)</span></label>
                                        <input
                                        id="ref"
                                        type="text"
                                        class="form-control font-size-13"
                                        v-model="selectedItem.ref"
                                        />
                                    </b-form-group>
                                    <b-form-group>
                                        <label  class="pt-1 pb-1 font-size-14 font-weight-bold">Marque </label>
                                        <v-select class="style-vselect" style="font-size:16px;" :options="brandsList" v-model="selectedItem.brand" placeholder="" label="name" >
                                            <span slot="no-options">Aucun élément dans la liste</span>
                                        </v-select>   
                                    </b-form-group>
                                    <b-form-group>
                                        <label  class="pt-1 pb-1 font-size-14 font-weight-bold">Groupe </label>
                                        <v-select class="style-vselect" style="font-size:16px;" :options="groupsList" v-model="selectedItem.itemGroup" placeholder="" label="name" >
                                            <span slot="no-options">Aucun élément dans la liste</span>
                                        </v-select>   
                                    </b-form-group>
                                    <b-form-group>
                                        <label  class="pt-1 pb-1 font-size-14 font-weight-bold">Catégorie </label>
                                        <v-select class="style-vselect" style="font-size:16px;" :options="categoriesList" v-model="selectedItem.category" placeholder="" label="name" >
                                            <span slot="no-options">Aucun élément dans la liste</span>
                                        </v-select>   
                                    </b-form-group>
                                    <b-form-group>
                                        <label for="price" class="pt-1 pb-1 font-size-14 font-weight-bold">Prix HT  <span class="text-danger mb-2" style="font-size:9px">(obligatoire)</span></label>
                                        <div class="input-group" >
                                            <input
                                            id="price"
                                            type="number"
                                            class="form-control font-size-13"
                                            v-model="selectedItem.price"
                                            /> 
                                            <div class="input-group-append">
                                                <span  class="input-group-text font-weight-bold font-size-13 text-primary">TND</span>
                                            </div>
                                        </div>
                                    </b-form-group>
                                    <b-form-group >
                                        <label for="taxes" class="pt-1 pb-1 font-size-14 font-weight-bold">Taxes <span class="text-danger mb-2" style="font-size:9px">(obligatoire)</span></label>
                                        <div class="input-group" > 
                                            <input
                                            type="number"
                                            min="0"
                                            max="100"
                                            class="form-control font-size-13"
                                            v-model="selectedItem.taxPercent " 
                                            />
                                            <div class="input-group-append">
                                                <span  class="input-group-text font-weight-bold font-size-13 text-primary">%</span>
                                            </div>
                                        </div>
                                    </b-form-group>
                                    <b-form-group>
                                        <label for="vat" class="pt-1 pb-1 font-size-14 font-weight-bold">TVA <span class="text-danger mb-2" style="font-size:9px">(obligatoire)</span></label>
                                        <div class="input-group" > 
                                            <input
                                            id="vat"
                                            type="number"
                                            class="form-control font-size-13"
                                            v-model="selectedItem.vatPercent " 
                                            />
                                            <div class="input-group-append">
                                                <span  class="input-group-text font-weight-bold font-size-13 text-primary">%</span>
                                            </div>
                                        </div>
                                    </b-form-group>
                                    <b-form-group>
                                        <label for="discount" class="pt-1 pb-1 font-size-14 font-weight-bold">Remise</label>
                                        <div class="input-group" > 
                                            <input
                                            id="discount"
                                            type="number"
                                            min="0"
                                            max="100"
                                            class="form-control font-size-13"
                                            v-model="selectedItem.discount " 
                                            />
                                            <div class="input-group-append">
                                                <span class="input-group-text font-weight-bold font-size-13 text-primary">%</span>
                                            </div>
                                        </div>
                                    </b-form-group>
                                    <b-form-group>
                                        <label class="font-weight-bold">Paliers de gratuité</label>

                                        <div
                                            v-for="(tier, index) in selectedItem.gratuity"
                                            :key="index"
                                            class="d-flex align-items-center mb-2"
                                        >
                                            <input
                                                type="number"
                                                min="1"
                                                class="form-control mr-2"
                                                v-model.number="tier.gratuity"
                                                placeholder="Quantité"
                                            />

                                            <i class="fa fa-arrow-right text-primary mr-2"></i>

                                            <input
                                                type="number"
                                                min="0"
                                                class="form-control mr-2"
                                                v-model.number="tier.gratuityGranted"
                                                placeholder="Gratuit"
                                            />

                                            <b-button
                                                variant="secondary"
                                                @click="removeTier(index)"
                                            >
                                                <i class="fas fa-times align-middle" style="font-size: 15px !important;"></i> 
                                            </b-button>
                                        </div>

                                        <div class="d-flex justify-content-end ">
                                            <b-button
                                                variant="primary"
                                                class="mt-2"
                                                @click="addTier()"
                                                >
                                                <i class="fas fa-plus align-middle mr-2" style="font-size: 13px !important;"></i> 
                                                Ajouter un palier
                                            </b-button>
                                         </div>
                                        
                                    </b-form-group>
                                    <b-form-group>
                                        <label for="multiple" class="pt-1 pb-1 font-size-14 font-weight-bold">Multiple </label>
                                        <input
                                        id="multiple"
                                        type="number"
                                        min="1"
                                        class="form-control font-size-13"
                                        v-model="selectedItem.multiple"
                                        />
                                    </b-form-group>
                                    <b-form-group>
                                        <label for="priorite" class="pt-1 pb-1 font-size-14 font-weight-bold">Priorité dans le catalogue</label>
                                        <input
                                        id="priority"
                                        class="form-control font-size-13"
                                        v-model="selectedItem.priority"
                                        />
                                        </b-form-group>
                                    <b-form-group>
                                        <div class="row">
                                            <div class="col-md-6 col-sm-12 custom-control custom-radio  mt-2 m-0 p-0 text-primary">
                                                <b-form-radio v-model="selectedItem.isAvailable"  value="1">Dispo en Stock</b-form-radio>
                                            </div>

                                            <div class="col-md-6 col-sm-12 custom-control custom-radio  mt-2 m-0 p-0  text-secondary">
                                                <b-form-radio v-model="selectedItem.isAvailable"   value="0">Indisponible</b-form-radio>
                                            </div>
                                        </div>
                                    </b-form-group>

                                    <div class="row pb-1 pt-1">
                                        <span v-if="if_form_error" class="text-danger font-size-10 font-italic" >{{this.if_form_error_message}}</span>
                                        <span v-if="!if_form_error" class="text-danger font-size-10 font-italic" style="visibility: hidden" >{{this.if_form_error_message}}</span>
                                    </div>
                                    <div class="row pb-0 pt-0">
                                        <div class="col-sm-6 pr-sm-3  pb-3" v-if="selectedItem.id">
                                            <b-button variant="secondary" style="width:100%" @click="cancelEdit()" :disabled="false">
                                                <i class="fas fa-times font-size-20 align-middle" style="font-size:10px;"></i> 
                                                <!-- <span class="font-size-14">Annuler</span> -->
                                            </b-button>
                                        </div>
                                        <div :class="selectedItem.id ? 'col-sm-6' : 'col-sm-12'">
                                            <b-button :variant="selectedItem.id ? 'info' : 'success'" style="width:100%" @click="confirm()" >
                                                <!-- <i class="bx bx-check-double font-size-24 align-middle mr-2"></i>  -->
                                                <span class="font-weight-bold font-size-14">{{selectedItem.id ? 'Modifier' : 'Nouvel Article'}}</span>
                                            </b-button>
                                        </div>
                                    </div>
                                </form>
                        </b-tab>
                        <b-tab lazy>
                            <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                                <i class="far fa-list-alt font-size-16"></i>
                            </span>
                            <i class="d-none d-sm-inline-block far fa-list-alt font-size-12 pr-2"/><span class="d-none d-md-inline-block font-size-12">Marques</span>
                            </template>
                                <h5 class="card-title pt-sm-0 pt-4 mt-sm-4  mb-2 text-secondary text-center">Modification Groupée</h5><br> 
       
                                    <div class="form-group  ">
                                        <label  class="pt-1 pb-1 font-size-14 font-weight-bold">Les Marques <span class="text-danger mb-2" style="font-size:9px">(obligatoire)</span></label>
                                        <v-select class="style-vselect" style="font-size:16px;" :options="brandsList" v-model="selectedBrand" placeholder="Choisissez une marque " label="name" >
                                            <span slot="no-options">Aucun élément dans la liste</span>
                                        </v-select>   
                                        <b-button
                                        variant="link"
                                        class="p-0 m-0 pt-3  text-primary font-weight-bold font-size-14" 
                                        @click="showBrandModal = true;"
                                        >
                                        <i class="fas fa-edit " ></i>
                                        <span class="ml-2">Gérer les marques</span>
                                    </b-button>
                                    </div>                  

                                    <b-form-group>
                                        <label for="BrandDiscount" class="pt-1 pb-1 font-size-14 font-weight-bold">Remises de la Marque </label>
                                        <div class="input-group" > 
                                            <input
                                        id="BrandDiscount"
                                        type="number"
                                        min="0"
                                        max="100"
                                        class="form-control"
                                        v-model="selectedBrandDiscount"
                                        />
                                        <div class="input-group-append">
                                            <span  class="input-group-text font-weight-bold font-size-13 text-primary">%</span>
                                        </div>
                                        </div>
                                    </b-form-group>


                                    <b-form-group>
                                        <label class="font-weight-bold">Paliers de gratuités de la Marque</label>

                                        <div
                                            v-for="(tier, index) in selectedBrandGratuity"
                                            :key="index"
                                            class="d-flex align-items-center mb-2"
                                        >
                                            <input
                                                type="number"
                                                min="1"
                                                class="form-control mr-2"
                                                v-model.number="tier.gratuity"
                                                placeholder="Quantité"
                                            />

                                            <i class="fa fa-arrow-right text-primary mr-2"></i>

                                            <input
                                                type="number"
                                                min="0"
                                                class="form-control mr-2"
                                                v-model.number="tier.gratuityGranted"
                                                placeholder="Gratuit"
                                            />

                                            <b-button
                                                variant="secondary"
                                                @click="removeBrandTier(index)"
                                            >
                                                <i class="fas fa-times align-middle" style="font-size: 15px !important;"></i> 
                                            </b-button>
                                        </div>

                                        <div class="d-flex justify-content-end ">
                                            <b-button
                                                variant="primary"
                                                class="mt-2"
                                                @click="addBrandTier()"
                                                >
                                                <i class="fas fa-plus align-middle mr-2" style="font-size: 13px !important;"></i> 
                                                Ajouter un palier
                                            </b-button>
                                         </div>
                                        
                                    </b-form-group>


                                    <div class="row pt-sm-3 mt-2 pb-4">
                                        <div class="col-sm-5 pr-sm-3  pb-3">
                                            <b-button variant="secondary" style="width:100%" @click="cancelModification()" :disabled="selectedBrand===null || (selectedBrandDiscount===null && selectedBrandGratuity ===null)" >
                                                <i class="fas fa-times align-middle" style="font-size: 15px !important;"></i> <span class="font-size-14"></span>
                                            </b-button>
                                        </div>
                                        <div class="col-sm-7">
                                            <b-button variant="success" style="width:100%" :disabled="selectedBrand===null || (selectedBrandDiscount===null && selectedBrandGratuity ===null)" @click="groupModif()">
                                                <!-- <i class="bx bx-check-double font-size-24 align-middle mr-2"></i>  -->
                                                <span class="font-weight-bold font-size-14">Modifier</span>
                                            </b-button>
                                        </div>
                                    </div>
                        </b-tab>
                        <b-tab  lazy >
                            <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                                <i class="fas fa-list-ol  font-size-16"></i>
                            </span>
                            <i class="d-none d-sm-inline-block fas fa-list-ol font-size-12 pr-2"/><span class="d-none d-md-inline-block font-size-12">Groupes</span>
                            </template>
                            <h5 class="card-title pt-sm-0 pt-4 mt-sm-4  mb-2 text-secondary text-center">Modification Groupée</h5><br> 

                            <div class="form-group  ">
                                <label  class="pt-1 pb-1 font-size-14 font-weight-bold">Les Groupes <span class="text-danger mb-2" style="font-size:9px">(obligatoire)</span></label>
                                <v-select class="style-vselect" style="font-size:16px;" :options="groupsList" v-model="selecteddGroup" placeholder="Choisissez un groupe" label="name" >
                                    <span slot="no-options">Aucun élément dans la liste</span>
                                </v-select>   
                                <b-button
                                variant="link"
                                class="p-0 m-0 pt-3  text-primary font-weight-bold font-size-14" 
                                @click="showGroupModal = true;"
                                >
                                <i class="fas fa-edit " ></i>
                                <span class="ml-2">Gérer les groupes</span>
                            </b-button>
                            </div>                  

                            <b-form-group>
                                <label for="GroupDiscount" class="pt-1 pb-1 font-size-14 font-weight-bold">Remises du groupe </label>
                                <div class="input-group" > 
                                    <input
                                id="GroupDiscount"
                                type="number"
                                min="0"
                                max="100"
                                class="form-control"
                                v-model="selectedGroupDiscount"
                                />
                                <div class="input-group-append">
                                    <span  class="input-group-text font-weight-bold font-size-13 text-primary">%</span>
                                </div>
                                </div>
                            </b-form-group>


                            <b-form-group>
                                <label class="font-weight-bold">Paliers de gratuités du Groupe</label>

                                <div
                                    v-for="(tier, index) in selectedGroupGratuity"
                                    :key="index"
                                    class="d-flex align-items-center mb-2"
                                >
                                    <input
                                        type="number"
                                        min="1"
                                        class="form-control mr-2"
                                        v-model.number="tier.gratuity"
                                        placeholder="Quantité"
                                    />

                                    <i class="fa fa-arrow-right text-primary mr-2"></i>

                                    <input
                                        type="number"
                                        min="0"
                                        class="form-control mr-2"
                                        v-model.number="tier.gratuityGranted"
                                        placeholder="Gratuit"
                                    />

                                    <b-button
                                        variant="secondary"
                                        @click="removeGroupTier(index)"
                                    >
                                        <i class="fas fa-times align-middle" style="font-size: 15px !important;"></i> 
                                    </b-button>
                                </div>

                                <div class="d-flex justify-content-end ">
                                    <b-button
                                        variant="primary"
                                        class="mt-2"
                                        @click="addGroupTier()"
                                        >
                                        <i class="fas fa-plus align-middle mr-2" style="font-size: 13px !important;"></i> 
                                        Ajouter un palier
                                    </b-button>
                                    </div>
                                
                            </b-form-group>

                            <div class="row pt-sm-3 mt-2 pb-4">
                                <div class="col-sm-5 pr-sm-3  pb-3">
                                    <b-button variant="secondary" style="width:100%" @click="cancelGroupModification()" :disabled="selecteddGroup===null || (selectedGroupDiscount===null && selectedGroupGratuity ===null)" >
                                        <i class="fas fa-times align-middle" style="font-size: 15px !important;"></i> <span class="font-size-14"></span>
                                    </b-button>
                                </div>
                                <div class="col-sm-7">
                                    <b-button variant="success" style="width:100%" :disabled="selecteddGroup===null || (selectedGroupDiscount===null && selectedGroupGratuity ===null)" @click="groupModifForGroup()">
                                        <!-- <i class="bx bx-check-double font-size-24 align-middle mr-2"></i>  -->
                                        <span class="font-weight-bold font-size-14">Modifier</span>
                                    </b-button>
                                </div>
                            </div>
                        </b-tab>
                    </b-tabs>
                </div>
            </div>
          </div>
        </div>
      </div>
       <b-modal v-model="showImageModal" 
        title="L'image de l'article" 
        hide-footer 
        centered 
        title-class="text-warning"
        title-tag="h5"
        header-close-variant="danger">
        <div class="zoom-container">
        <div class="row p-2">
            <img v-bind:src="imageModalUrl"  alt style="width: 100%; height: 100%;" />
        </div>
        <b-alert show variant="warning" class="text-justify">
            <i class="mdi mdi-alert-outline mr-2"></i>La taille de l'image ne doit pas dépasser <span class="font-weight-bold" > {{this.maxFileSize}}</span>. 
            Les types supportés sont <span class="font-weight-bold"> PNG </span>, <span class="font-weight-bold">JPG </span>, <span class="font-weight-bold"> BMP</span>, et <span class="font-weight-bold">GIF</span>. 
        </b-alert>
            <input 
            type="file" 
            @change="onImageUpload"
            ref="imageInput"
            style="display:none"/>
            <div class="row">
                <div class="col-5 text-left">
                    <b-button variant="outline-info" class="mt-2"  @click="$refs.imageInput.click()">
                        <i class="fas fa-upload font-size-12 align-middle mr-2"></i> <span class="font-weight-bold font-size-12">Modifier</span>
                    </b-button>
                </div>

                <div class="col-2">
                </div>

                <div class="col-5 text-right">
                    <b-button variant="outline-danger" class="mt-2"  @click="deleteImage(imageModalSelectedItem)">
                        <i class="fas fa-times font-size-12 align-middle mr-2"></i> <span class="font-weight-bold font-size-12">Supprimer</span>
                    </b-button>
                </div>
            </div>
        </div>
        </b-modal>
        <b-modal v-model="showBrandModal"
            title="Gérer les marques" 
            hide-footer 
            centered 
            title-class="text-warning"
            title-tag="h5"
            header-close-variant="danger"
            size="md">
            <div class="zoom-container">
                <div class="row pb-4">
                    <div class="col-9 col-xs-7">
                        <b-form-input 
                            placeholder="Ajouter une nouvelle marque" 
                            for="newBrand" 
                            v-model="newBrandName"
                            @keyup.native.enter="addNewBrand(newBrandName)" >
                        </b-form-input>
                    </div>
                    <div class="col-2 col-xs-5 text-right">
                        <b-button
                            variant="outline-primary pill"
                            class=" ml-sm-4 ml-2 p-0 m-0" 
                            @click="addNewBrand(newBrandName)"
                            style="width:100%;height:36px"
                            :disabled="newBrandName===null || newBrandName==''"
                            >
                            <i class="fas fa-plus font-size-14 align-middle p-0 pr-sm-1 m-0"  ></i><span class="font-weight-bold font-size-12 d-none d-sm-inline"  >Ajouter</span>
                        </b-button>
                    </div>
                </div>
            
                <div class="table-responsive" style="height:250px;" >
                    <table class="table table-centered " >
                    <tbody>
                        <tr v-for="brand in brandsList" :key="brand.id" >
                            <td v-if="editedBrand!=brand" >{{brand.name}}</td>
                            <td v-if="editedBrand==brand">
                                <div class="row">
                                    <div class="col-11">
                                        <b-form-input 
                                            v-model="editedName"   
                                            @keyup.native.enter="saveModif(brand)"
                                        ></b-form-input>  
                                    </div>
                                    <div class="col-1 pl-sm-2">
                                        <b-button
                                            variant="link"
                                            class="mt-0 pt-2 mb-0  pl-0 pb-0 text-danger" 
                                            @click="cancelBrand()"
                                            >
                                            <i class="fas fa-times font-size-16 align-middle ml-1 mr-0"></i>
                                        </b-button>
                                    </div>
                                </div>
                            </td>
                            <td v-if="editedBrand!=brand" class="text-right">
                                <b-button
                                    variant="link"
                                    class="mt-0 pt-2 mb-0  pl-0 pb-0 text-primary" 
                                    @click="editBrand(brand)"
                                    >
                                    <i class="fas fa-pencil-alt font-size-16 align-middle mr-0" ></i>
                                    <span class="ml-2 d-none d-sm-inline">Modifier</span>
                                </b-button>
                            </td>
                            <td v-if="editedBrand==brand" class="text-right">
                                <b-button
                                    variant="link"
                                    class="mt-0 pt-2 mb-0  pl-0 pb-0 text-primary" 
                                    @click="saveModif(brand)"
                                    >
                                    <i class="fas fa-save font-size-16 align-middle mr-0" ></i>
                                    <span class="ml-2 d-none d-sm-inline">Enregistrer</span>
                                </b-button>
                            </td>
                            <td class="text-right"> 
                                <b-button
                                    variant="link"
                                    class="mt-0 pt-2 mb-0  pl-0 pb-0 text-danger" 
                                    @click="deleteBrand(brand)"
                                    >
                                        <i class="fas fa-trash font-size-16 align-middle mr-0" ></i>
                                    <span class="ml-2 d-none d-sm-inline">Supprimer</span>
                                </b-button>
                            </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
            </div>

        </b-modal>
        <b-modal v-model="showGroupModal"
            title="Gérer les groupes" 
            hide-footer 
            centered 
            title-class="text-warning"
            title-tag="h5"
            header-close-variant="danger"
            size="md">
            <div class="zoom-container">
                <div class="row pb-4">
                    <div class="col-9 col-xs-7">
                        <b-form-input 
                            placeholder="Ajouter un nouveau groupe" 
                            for="newGroup" 
                            v-model="newGroupName"
                            @keyup.native.enter="addNewGroup(newGroupName)" >
                        </b-form-input>
                    </div>
                    <div class="col-2 col-xs-5 text-right">
                        <b-button
                            variant="outline-primary pill"
                            class=" ml-sm-4 ml-2 p-0 m-0" 
                            @click="addNewGroup(newGroupName)"
                            style="width:100%;height:36px"
                            :disabled="newGroupName===null || newGroupName==''"
                            >
                            <i class="fas fa-plus font-size-14 align-middle p-0 pr-sm-1 m-0"  ></i><span class="font-weight-bold font-size-12 d-none d-sm-inline"  >Ajouter</span>
                        </b-button>
                    </div>
                </div>
  
                <div class="table-responsive" style="height:250px;" >
                    <table class="table table-centered " >
                    <tbody>
                        <tr v-for="itemGroup in groupsList" :key="itemGroup.id" >
                            <td v-if="editedGroup!=itemGroup" >{{itemGroup.name}}</td>
                            <td v-if="editedGroup==itemGroup">
                                <div class="row">
                                    <div class="col-11">
                                        <b-form-input 
                                            v-model="editedGroupName"   
                                            @keyup.native.enter="saveGroupModif(itemGroup)"
                                        ></b-form-input>  
                                    </div>
                                    <div class="col-1 pl-sm-2">
                                        <b-button
                                            variant="link"
                                            class="mt-0 pt-2 mb-0  pl-0 pb-0 text-danger" 
                                            @click="cancelGroup()"
                                            >
                                            <i class="fas fa-times font-size-16 align-middle ml-1 mr-0"></i>
                                        </b-button>
                                    </div>
                                </div>
                            </td>
                            <td v-if="editedGroup!=itemGroup" class="text-right">
                                <b-button
                                    variant="link"
                                    class="mt-0 pt-2 mb-0  pl-0 pb-0 text-primary" 
                                    @click="editGroup(itemGroup)"
                                    >
                                    <i class="fas fa-pencil-alt font-size-16 align-middle mr-0" ></i>
                                    <span class="ml-2 d-none d-sm-inline">Modifier</span>
                                </b-button>
                            </td>
                            <td v-if="editedGroup==itemGroup" class="text-right">
                                <b-button
                                    variant="link"
                                    class="mt-0 pt-2 mb-0  pl-0 pb-0 text-primary" 
                                    @click="saveGroupModif(itemGroup)"
                                    >
                                    <i class="fas fa-save font-size-16 align-middle mr-0" ></i>
                                    <span class="ml-2 d-none d-sm-inline">Enregistrer</span>
                                </b-button>
                            </td>
                            <td class="text-right"> 
                                <b-button
                                    variant="link"
                                    class="mt-0 pt-2 mb-0  pl-0 pb-0 text-danger" 
                                    @click="deleteGroup(itemGroup)"
                                    >
                                        <i class="fas fa-trash font-size-16 align-middle mr-0" ></i>
                                    <span class="ml-2 d-none d-sm-inline">Supprimer</span>
                                </b-button>
                            </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
            </div>

        </b-modal>
    </div>
  </Layout>
</template>
<style>
.mdi:before, .mdi-set {
    display: inline;
}

.truncate-title {
  white-space: nowrap; 
  width: 100% ;
  overflow: hidden;
  text-overflow: ellipsis; 
}

input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus, 
input:-webkit-autofill:active  {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
     box-shadow: 0 0 0 30px white inset;
}

</style>
